export default __webpack_public_path__ + "static/media/LandRover-Logo-2D-WHT.09be25b0.png";